document.addEventListener('DOMContentLoaded', function () {
  const select = document.getElementById('insurance-select') as HTMLSelectElement | null
  const button = document.getElementById('go-to-insurance') as HTMLAnchorElement | null

  if (select && button) {
    if (button.href === '#' || !button.href) {
      button.classList.add('disabled-btn')
      button.setAttribute('aria-disabled', 'true')
    }

    select.addEventListener('change', function () {
      const selectedValue = select.value
      if (selectedValue) {
        button.setAttribute('aria-disabled', 'false')
        button.classList.remove('disabled-btn')
        button.setAttribute('href', selectedValue)
      } else {
        button.setAttribute('aria-disabled', 'true')
        button.classList.add('disabled-btn')
        button.setAttribute('href', '#')
      }
    })

    button.addEventListener('click', function (event) {
      if (button.getAttribute('href') === '#' || !button.getAttribute('href')) {
        event.preventDefault()
      }
    })
  }
})
